module.exports = __webpack_public_path__ + "static/4843d2933aa729e3433bc0617a5e75a8.png";